import { render } from "./CurrencySelector.vue?vue&type=template&id=18dcccc1&scoped=true"
import script from "./CurrencySelector.vue?vue&type=script&lang=js"
export * from "./CurrencySelector.vue?vue&type=script&lang=js"

import "./CurrencySelector.vue?vue&type=style&index=0&id=18dcccc1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dcccc1"]])

export default __exports__